export default function (cartData) {
	let result = 0;

	cartData.forEach((item) => {
		if (item?.quantity >= 1) {
			result += item.quantity;
		} else {
			result++;
		}
	});

	return result;
}
